import {
    Box,
    CircularProgress,
    FormControl,
    FormHelperText,
    InputLabel,
    MenuItem,
    Select,
    SelectProps,
} from '@mui/material';
import React from 'react';

import { useCobranders } from 'app/hooks/use-cobranders';

type CobranderSelectorProps = SelectProps<string | undefined> & {
    helperText?: string;

    variant?: 'filled' | 'outlined' | 'standard';
    size?: 'medium' | 'small';
};

export const CobranderSelector: React.FunctionComponent<CobranderSelectorProps> = (props) => {
    const { helperText, variant, required, size, sx, className, label, value, ...rest } = props;

    const { loaded, cobranders } = useCobranders();

    const realLabel = label || 'Cobrander';

    // const onChangeCallback = React.useCallback((event: SelectChangeEvent, child: React.ReactNode) => {
    //     const cobrander = cobranders.find((cobr) => cobr.id === event.target.value);
    //
    //     const newEvent = event as SelectChangeEvent<Cobrander | undefined>;
    //     newEvent.target.value = cobrander;
    //
    //     return onChange?.(newEvent, child);
    // }, [cobranders, onChange]);

    return (
        <FormControl variant={variant} size={size} sx={sx} className={className}>
            <InputLabel required={required} error={props.error} shrink>
                {realLabel}
            </InputLabel>
            <Select
                startAdornment={
                    !loaded ? (
                        <Box sx={{ display: 'flex' }}>
                            <CircularProgress size='1rem' />
                        </Box>
                    ) : undefined
                }
                {...rest}
                label={realLabel}
                displayEmpty
                notched
                value={undefined === value ? '' : value}
            >
                <MenuItem value=''>
                    <em>All</em>
                </MenuItem>
                {cobranders.map((cobrander) => (
                    <MenuItem key={cobrander.id} value={cobrander.id}>
                        {cobrander.name}
                    </MenuItem>
                ))}
            </Select>
            {helperText && <FormHelperText error={props.error}>{helperText}</FormHelperText>}
        </FormControl>
    );
};
